function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { LocalizableMessage, LocalizableMessageShape } from 'components/LocalizableMessage/LocalizableMessage';
export var SimpleBanner = function SimpleBanner(_ref) {
  var type = _ref.type,
      onClose = _ref.onClose,
      message = _ref.message,
      unclosable = _ref.unclosable;
  return React.createElement("div", {
    className: classNames('banner anim anim--slideInDown', _defineProperty({}, "banner--".concat(type), type))
  }, !unclosable && React.createElement("span", {
    className: "banner__close",
    onClick: onClose
  }, "x"), React.createElement(LocalizableMessage, {
    message: message
  }));
};
SimpleBanner.propTypes = {
  message: LocalizableMessageShape.isRequired,
  onClose: PropTypes.func.isRequired,
  unclosable: PropTypes.bool,
  type: PropTypes.string
};